import styled from "styled-components";

import { Check } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const Container = styled(Flex)<{ $isSuccess: boolean }>`
    position: relative;
    min-height: 340px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${({ $isSuccess }) => ($isSuccess ? "0 30px" : "0 30px 36px 30px")};
    box-sizing: border-box;
    gap: 24px;
`;

export const IconContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
`;

export const Title = styled(Text)``;

export const Description = styled.div`
    text-align: center;
`;

export const TextFailed = styled(Text)`
    cursor: pointer;
    padding: 0;
    text-transform: lowercase;
    vertical-align: baseline;
`;

export const ButtonCloseWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
`;

export const ButtonsHeaderWrapper = styled(Flex)`
    justify-content: flex-end;
    padding: 10px;
`;

export const ImageFailed = styled.img`
    width: 140px;
`;

export const Actions = styled(Flex)`
    flex-direction: column;
    gap: 16px;
`;

export const LoaderWrapper = styled(Flex)`
    flex-direction: column;
`;

export const SuccessfulTextContainer = styled(Flex)`
    flex-direction: column;
    gap: 24px;
`;

export const SuccessfulSubtitleContainer = styled(Flex)`
    flex-direction: column;
    align-items: center;
`;

export const SuccessIconCheck = styled(Check)``;

export const SuccessIconContainer = styled(Flex)`
    position: relative;
    background: ${colorsPalettes.solutions["INVESTORS"]};
    filter: drop-shadow(0 4px 24px ${rgba(colorsPalettes.solutions["INVESTORS"], 0.4)});
    backdrop-filter: blur(15px);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
`;

export const ConfettiWrapper = styled(Flex)`
    position: fixed;
    top: 0;
    left: 0;
`;
